import { isToday, format } from "date-fns";

/**
 * Convert date from server to local date
 * @param {string} value - utc string from server
 */
export function getLocalDate(value) {
  const utcDate = new Date(value);
  return new Date(
    Date.UTC(
      utcDate.getFullYear(),
      utcDate.getMonth(),
      utcDate.getDate(),
      utcDate.getHours(),
      utcDate.getMinutes(),
      utcDate.getSeconds()
    )
  );
}

export function getDate() {
  const utcDate = new Date();
  return new Date(
    Date.UTC(
      utcDate.getFullYear(),
      utcDate.getMonth(),
      utcDate.getDate(),
      utcDate.getHours(),
      utcDate.getMinutes(),
      utcDate.getSeconds()
    )
  );
}

export function toShortLocalDate(value) {
  if (!value) return "";
  var date = new Date(value);
  var dateNow = new Date();
  if (date > dateNow) {
    return format(date, "dd MMM HH:mm");
  }
  if (date.getFullYear() < dateNow.getFullYear())
    return format(date, "dd MMM, yyyy");
  else {
    if (isToday(date)) return format(date, "HH:mm");
    else return format(date, "dd MMM");
  }
}

export function getTimeDate(value) {
  if (!value) return "";
  var date = new Date(value);
  var dateNow = new Date();
  if (date.getFullYear() < dateNow.getFullYear())
    return format(date, "dd MMM, yyyy HH:mm");
  else if (isToday(date)) return format(date, "HH:mm");

  return format(date, "dd MMM HH:mm");
}

export function getAge(value) {
  if (!value) return "";
  var date = new Date(value);
  var dateNow = new Date();
  return dateNow.getFullYear() - date.getFullYear();
}

export function differenceDays(value) {
  if (!value) return "";
  const time1 = new Date(value).getTime();
  const time2 = new Date().getTime();
  const diffInMs = Math.abs(time2 - time1);
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
}

export function toLastLocalDate(value) {
  if (!value) return "";
  var date = new Date(value);
  var dateNow = new Date();
  if (date.getFullYear() < dateNow.getFullYear())
    return format(date, "dd MMM, yyyy");
  else {
    if (isToday(date)) return `Today ${format(date, "HH:mm")}`;
    return format(date, "dd MMM HH:mm");
  }
}

export function toShortDate(value) {
  if (!value) return "";
  var date = new Date(value);
  var dateNow = new Date();
  if (date > dateNow) {
    return format(date, "dd MMM HH:mm");
  }
  if (date.getFullYear() < dateNow.getFullYear())
    return format(date, "dd MMM, yyyy");
  else {
    if (isToday(date)) return format(date, "HH:mm");
    else return format(date, "dd MMM");
  }
}

export function toLocalMessageDate(value) {
  if (!value) return "";
  return format(new Date(value), "MMMM dd");
}

export function toLocalFormatDate(value) {
  if (!value) return "";
  const year = getLocalDate(value).getFullYear();
  if (!value || year < 1970) return "Not edited yet";

  return format(getLocalDate(value), "dd MMM, yyyy");
}

export function toDsDate(value) {
  if (!value) return "";
  return format(value, "yyyy-MM-dd");
}
export function toDsDateTime(value) {
  if (!value) return "";
  return format(getLocalDate(value), "yyyy-MM-dd");
}

export function setDate(value) {
  if (!value) return "";
  return new Date(value).toISOString(); //.slice(0, 19);
  //return format(getLocalDate(value), "yyyy-MM-dd HH:mm:ss");
}

export function toflatPickrDateTime(value) {
  if (!value) return "";
  return format(new Date(value), "MM-dd-yyyy HH:mm");
}
